import React, { useState } from 'react';
import { useLoadingScreen } from '../../Store/LoadingManager';

import { useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";

import { Typography, Box } from "@mui/material";
import { RecoverAccountContainer, RecoverAccountStyledCard } from '../../Styles/Authentication/authenticationStyles';

import { useAuthenticationHook } from '../../Hooks/Authentication/authenticationHooks';

import RequiredParametersHelper from '../../Utilities/Helpers/RequiredParametersHelper';
import RequiredFieldHelper from '../../Utilities/Helpers/RequiredFieldHelper';
import RouteHelper from '../../Utilities/Helpers/RouteHelper';
import LocalStorageHelper from '../../Utilities/Helpers/LocalStorageHelper';

import { RouteEnum } from '../../Utilities/Enums/RouteEnums';
import { ButtonType } from '../../Utilities/Enums/ButtonTypeEnum';

import { AssetImages } from "../../Constants/Assets";

import CustomButton from '../../CustomViews/Elements/CustomButton';
import FormTextField from '../../CustomViews/Elements/FormTextField';
import AuthFooter from './AuthFooter';

export default function RecoverAccount() {
    const navigate = useNavigate();
    const { recover2FA, verifyRecover2FA } = useAuthenticationHook();
    const { enqueueSnackbar } = useSnackbar();
    let requiredFields = RequiredParametersHelper.recoverAccountEmail();
    let verifyRecoveryrequiredFields = RequiredParametersHelper.verifyRecoverAccountEmail();
    const { loading, setLoading } = useLoadingScreen();

    //Use States
    let [emailAddress, setemailAddress] = useState<any>("");
    let [authCode, setauthCode] = useState<any>("");
    const [isEmailSent, setisEmailSent] = useState(false);
    const [alreadyHaveRecoveryCode, setalreadyHaveRecoveryCode] = useState(false);
    const [errorMessages, setErrorMessages]: any = useState({});

    //Variables
    const emailAddressProps = {
        name: "userEmail",
        title: 'Email Address',
        placeholder: 'Email Address',
        fieldValue: emailAddress ?? "",
        type: 'text',
        required: requiredFields?.find((field: any) => field.keyName == "code")?.keyName != null,
        hideLabel: true,
        errorMessages: errorMessages,
        handleOnChange: (selectedValue: any) => {
            setemailAddress(selectedValue);
        },
    },
        authCodeProps = {
            name: "code",
            title: 'Recovery Code',
            placeholder: 'Recovery Code',
            fieldValue: authCode ?? "",
            type: 'text',
            required: requiredFields?.find((field: any) => field.keyName == "code")?.keyName != null,
            hideLabel: true,
            errorMessages: errorMessages,
            handleOnChange: (selectedValue: any) => {
                setauthCode(selectedValue);
            },
        };

    //Event Handlers
    const handleSubmitEmail = async () => {
        let _formData = {
            userEmail: emailAddress,
        };

        let _validateForm = RequiredFieldHelper.validateForm(requiredFields, _formData, errorMessages, setErrorMessages, enqueueSnackbar);

        if (_validateForm?.hasError) { return true; }

        setLoading(true);
        
        let sendEmailResponse = await recover2FA(JSON.stringify(_formData));

        if(sendEmailResponse?.isSuccess || sendEmailResponse?.message == "A temporary password has already been sent. Please check your email or try again in later.") {
            setisEmailSent(true);
        }
    }

    const handleSubmitRecoveryCode = async () => {
        let _formData = {
            userEmail: emailAddress,
            code: authCode,
        };

        let _validateForm = RequiredFieldHelper.validateForm(verifyRecoveryrequiredFields, _formData, errorMessages, setErrorMessages, enqueueSnackbar);

        if (_validateForm?.hasError) { return true; }

        setLoading(true);
        
        let verifyRecoveryCodeResponse = await verifyRecover2FA(JSON.stringify(_formData));

        if(verifyRecoveryCodeResponse?.isSuccess) {
            LocalStorageHelper.clearLocalStorage();
            setisEmailSent(false);

            navigate(RouteEnum.LOGIN, { replace: true });

        }
    }

    //Rendering Functions
    return <RecoverAccountContainer className='glossy-box'>
        <div className="recoverAccountBgContainer">
            <RecoverAccountStyledCard elevation={3}>
                <div className="recoverAccountFormContainer">
                    <div className="formContainer">
                        <img src={AssetImages.WEB_APP_LOGO} />
                        <Typography color="primaryText" className="headerText">{RouteHelper.getRouteDescription(RouteEnum.RECOVER_ACCOUNT)}</Typography>
                        <Typography color="primaryText" className="subHeaderText">Please enter email address where the account recovery code will be send.</Typography>
                        

                        <div className="fieldsContainer">
                            {(!isEmailSent || alreadyHaveRecoveryCode) && <FormTextField fieldClassName={alreadyHaveRecoveryCode ? "emailAddressField" : ""} {...emailAddressProps} />}
                            {(isEmailSent || alreadyHaveRecoveryCode) && <FormTextField {...authCodeProps} />}
                            {!alreadyHaveRecoveryCode && <div className="recoverAccountLink" onClick={() => { setalreadyHaveRecoveryCode(true); }}>Already have recovery code ?</div>}
                        </div>

                        <CustomButton
                            btnType={ButtonType.PRIMARY}
                            title='Submit'
                            className="submitBtn"
                            onClick={(e: any) => {
                                if(isEmailSent || alreadyHaveRecoveryCode) {
                                    handleSubmitRecoveryCode();
                                } else {
                                    handleSubmitEmail();
                                }
                            }} />

                        <div className="goBackLink" onClick={() => { navigate(RouteEnum.OTP, { replace: true }); }}>Go Back</div>
                    </div>

                    <div className="spacer2" />
                    
                    <AuthFooter />
                </div>
            </RecoverAccountStyledCard>
        </div>
    </RecoverAccountContainer>
}